// Feature: M004-F0736 (pairs with Ledger ML001-F0235, ML001-D013 §2.62)
// Tests: T-M004-0271, T-M004-0272
//
// The small confirm dialog behind Reject and Restore on an Advice item. The reason is the owner's own words and is mandatory:
// Save stays disabled until the trimmed text is non-empty (and at most 500 characters, the Ledger's limit). The dialog never
// fills the field in; closing it sends nothing.

import React, { useEffect, useRef, useState } from 'react';
import { MAX_REASON_LENGTH } from '../../services/ledgerQueuesAdapter';

const COPY = {
  reject: {
    title: 'Reject this cost',
    lead: 'It will move to Rejected and will not be billed. Nothing is deleted; you can restore it from there.',
    label: 'Reason (required)',
    placeholder: 'e.g. duplicate of the Tuesday booking',
    save: 'Reject',
    busy: 'Rejecting…',
  },
  restore: {
    title: 'Restore this cost',
    lead: 'It will go back to Advice.',
    label: 'Reason for restoring (required)',
    placeholder: 'e.g. rejected the wrong one',
    save: 'Restore',
    busy: 'Restoring…',
  },
};

export default function ReasonDialog({ action, subject, busy = false, error = '', onSave, onCancel }) {
  const copy = COPY[action] || COPY.reject;
  const [reason, setReason] = useState('');
  const field = useRef(null);
  useEffect(() => { if (field.current) field.current.focus(); }, []);
  const trimmed = reason.trim();
  const valid = trimmed.length > 0 && trimmed.length <= MAX_REASON_LENGTH;
  const submit = (event) => {
    event.preventDefault();
    if (valid && !busy) onSave(trimmed);
  };
  const onKeyDown = (event) => { if (event.key === 'Escape' && !busy) onCancel(); };
  return <div className="ledger-reason-backdrop" onKeyDown={onKeyDown}>
    <form className="ledger-reason-dialog" role="dialog" aria-modal="true" aria-labelledby="ledger-reason-title" data-testid="ledger-reason-dialog" data-action={action} onSubmit={submit} noValidate>
      <h4 id="ledger-reason-title">{copy.title}</h4>
      {subject ? <p className="ledger-queue-hint" data-testid="ledger-reason-subject">{subject}</p> : null}
      <p className="ledger-queue-hint">{copy.lead}</p>
      <label>{copy.label}
        <textarea ref={field} required rows={3} maxLength={MAX_REASON_LENGTH} value={reason} placeholder={copy.placeholder}
          data-testid="ledger-reason-input" onChange={(event) => setReason(event.target.value)} />
      </label>
      <span className="ledger-queue-muted" aria-live="polite">{trimmed.length}/{MAX_REASON_LENGTH}</span>
      {error ? <p className="ledger-account-error" role="alert">{error}</p> : null}
      <div className="ledger-reason-actions">
        <button type="button" onClick={onCancel} disabled={busy} data-testid="ledger-reason-cancel">Cancel</button>
        <button type="submit" className="ledger-queue-primary" disabled={!valid || busy} data-testid="ledger-reason-save">{busy ? copy.busy : copy.save}</button>
      </div>
    </form>
  </div>;
}
